import Sunny16BaseService from '@/services/Sunny16BaseService'

import type { BatchRequest, BatchResponse, CatalogContentEnvelope } from '@/types/content'

class Sunny16ContentService extends Sunny16BaseService {
  constructor() {
    super(import.meta.env.VITE_SUNNY_16_STOREFRONT_API_BASE_URL, 'Sunny16ContentService')
  }
  async getBatchContent(request: BatchRequest): Promise<BatchResponse> {
    try {
      const response = await this.axiosInstance.post('/content/batch', request)
      return response.data
    } catch (error) {
      throw error
    }
  }
  async getBookingCatalogContent(catalogId: string): Promise<CatalogContentEnvelope> {
    try {
      const response = await this.axiosInstance.get(`/booking/content/catalog/${catalogId}`)
      return response.data
    } catch (error) {
      throw error
    }
  }
}

export default Sunny16ContentService
